import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {Router, ActivatedRoute, Params} from '@angular/router';
import 'rxjs/add/operator/switchMap';
import {PlaylistService, ScrollService, AuthService, ScrollParams} from '../../api/';
import * as _ from 'lodash';
import {PlayerService} from '../../player/services/player.service';
import {EditPlaylistComponent} from '../edit-playlist/edit-playlist.component';
import {MdDialog, MdDialogRef} from '@angular/material';
import { Location } from '@angular/common';
import { Globals } from '../../app.globals';
import { NgBlockUI, BlockUI } from 'ng-block-ui';
declare var $: any;

@Component({
    selector: 'app-playlist-detail',
    templateUrl: './playlist-detail.component.html',
    styleUrls: ['./playlist-detail.component.css']
})
export class PlaylistDetailComponent implements OnInit {
    public displayBackBtn = true;
    private playlist: any;
    private readMore: boolean = false;
    private readMore2: boolean = false;
    private playlistBio: string = '';
    private playlistDesc: string = '';
    private notfound: boolean = false;
    private checkIfMobile: boolean = false;
    private songs: Array<any>;
    public creditsArray: any = [];
    public writersArray: any = [];
    public onlineOffline1: boolean = navigator.onLine;
    public apiUrl: string = new Globals().apiEndpoint;
    dialogRef: MdDialogRef<EditPlaylistComponent>;
    @Output() refreshPlaylist: EventEmitter<any> = new EventEmitter();
    @BlockUI() blockUI: NgBlockUI;
    localStoragePlaylists: any;
    private scrollParams = new ScrollParams();
    playlistSlug:any;
    scrollSubscriber: any = null;
    playlistExists: boolean = false;

    constructor(private location: Location,private playerService: PlayerService,public dialog: MdDialog, private route: ActivatedRoute, private router: Router, private playlistService: PlaylistService,
    private scrollService: ScrollService, private authService: AuthService) {
        window.addEventListener('online', () => {this.onlineOffline1 = true; });
        window.addEventListener('offline', () => {this.onlineOffline1 = false});
        // to update the data of playlist without refresh
        this.playlistService.isPlaylistUpdated.subscribe(res=> {
            if (res == true) {
                this.route.params.subscribe((params) => {
                    this.checkPlaylistExists(params['id']);
                });
            }
        });
    }

    back() {
        this.location.back();
    }

    ngOnInit() {
        if (screen.width <= 667) {
            // var btn = document.getElementById("123");
            // btn.click();
            this.checkIfMobile = true;
        }
        if (screen.width <= 320) {
            // var btn = document.getElementById("123");
            // btn.click();
        }
        this.scrollService.toggleProgressBar(true);

        this.route.params.subscribe((params) => {
            this.checkPlaylistExists(params['id']);
        });

        if(this.onlineOffline1) {
            this.route.params.subscribe((params) => {
                // this.getPlaylistDetail(params['id']);
            });
            this.route.params.subscribe((params) => {
                if(params['user_id']) {
                    localStorage.setItem('share_id',params['user_id']);
                    localStorage.setItem('download_share_id',params['user_id']);
                }
            });
        } else {
            this.scrollService.toggleProgressBar(false);
        }
        this.scrollService.enableScrollIfDisabled();
        // to check if the url is for share purpose
        this.route.queryParams.subscribe((params) => {
            if(params['share']) {
                // to slide the menu and enable full page view
                var btn = document.getElementById("123");
                btn.click();
                this.displayBackBtn = false;
                setTimeout(() => {
                    // to adjust the volume
                    this.playerService.adjustVolumeSlider(50);
                }, 2000);
            }
        });
        this.scrollSubscriber = this.scrollService.onScroll.subscribe((event) =>  this.getPlaylistSongs());
    }

    checkPlaylistExists(slug) {
        var localPlaylists = [];
        this.scrollParams.page = 1;
        this.localStoragePlaylists = JSON.parse(localStorage.getItem('playlistDetail'));
        if(this.localStoragePlaylists && typeof this.localStoragePlaylists != 'undefined') {
            localPlaylists = this.localStoragePlaylists.filter(x => x.slug == slug);
        }
        if(localPlaylists.length > 0) {
            //this.playlistExists = true;
            this.playlistExists = false;
            this.playlist = localPlaylists[0];
            if(this.playlist.bio) {
                this.playlistBio = this.playlist.bio.slice(0, 500);
                this.readMore = false;
            }
            if(this.playlist.description) {
                var regExp = this.playlist.description.split('|');
                this.playlistDesc = regExp[0];
            }
            var regExp = this.playlist.description.split('|');
            this.playlistDesc = regExp[0];
            this.playlist.songs = [];
            //this.getPlaylistSongs();
            this.getPlaylistDetail(slug);
        } else {
            this.playlistExists = false;
            this.getPlaylistDetail(slug);
        }
    }

    getPlaylistDetail(slug) {
        this.blockUI.start('Loading, please wait...');
        var that = this;
        $.get(this.apiUrl+'playlists/by-slug/' + slug).done(
            function(res) {
                that.playlist = res;
                if(that.playlist) {
                    if (that.playlist.type === 'R') {
                        localStorage.setItem("radio", '1');
                        localStorage.setItem("response", '1');
                        setInterval(() => {
                            if (localStorage.getItem("radio") == "1" && localStorage.getItem("response") == "1") {
                              that.playerService.checkRadio();
                            }
                        }, 2500);
                    } else {
                        localStorage.setItem("radio", '0');
                    }
                    if(res.bio) {
                      that.playlistBio = res.bio.slice(0, 500);
                      that.readMore = false;
                    }
                    if(res.description) {
                        var regExp = res.description.split('|');
                        that.playlistDesc = regExp[0];
                    }
                    that.playlist.songs.forEach((arrayItem) => {
                        arrayItem.playedFrom = 'playlist';
                        arrayItem.playlistId = that.playlist.id;
                        arrayItem.parentId = that.playlist.id;
                        arrayItem.parentName = that.playlist.name;
                        arrayItem.ParentSlug = that.playlist.slug;
                    });
                    that.scrollService.toggleProgressBar(false);

                    var mta = document.getElementById("metaImage");
                    if(mta) {
                        if(that.playlist.artist.image) {
                            document.getElementById("metaImage").setAttribute("content", this.playlist.artist.image);
                        }
                    }
                    that.blockUI.stop();
                } else {
                    that.blockUI.stop();
                    that.scrollService.toggleProgressBar(false);
                    that.notfound = true;
                }
            }
        );
    }

    private dropSuccess(args) {
        let newOrder = [];
        let i = 0;
        this.playlist.songs.forEach((arrayItem) => {
            let song: any = {};
            let tmp: any = _.pick(arrayItem, ['id']);
            song.song_id = tmp.id;
            song.order = i;
            i++;
            newOrder.push(song);
        });
        this.playlistService.setNewSongsOrder(this.playlist.id, newOrder).subscribe((res) => {
        });
    }

    editPlaylist(event) {
        event.stopPropagation();
        event.preventDefault();
        this.dialogRef = this.dialog.open(EditPlaylistComponent, {
            disableClose: false,
            width: '800px'
        });
        this.dialogRef.componentInstance.playlist = this.playlist;
        this.dialogRef.afterClosed().subscribe(result => {
            this.refreshPlaylist.emit({refresh: 1});
            this.dialogRef = null;
        });
    }

    handleDeleteEvent() {
        this.playlistService.getPlaylistDetail(this.playlist.id).subscribe((res) => {
            this.playlist = res;
            this.playlist = this.playlistService.simplify(this.playlist);
            this.playlist.songs.forEach((arrayItem) => {
                arrayItem.playedFrom = 'playlist';
                arrayItem.playlistId = this.playlist.id;
            });
        },
        (error) => {
            console.log(error);
        });
    }

    toggleReadMore() {
        this.readMore = !this.readMore;
    }

    toggleReadMore2() {
        this.readMore2 = !this.readMore2;
    }

    getPlaylistSongs() {
        if(this.playlistExists) {
            this.playlistService.getPlaylistSongsList(this.playlist.songsId, this.scrollParams.page).subscribe(res => {
                res['songs'].forEach(element => {
                    this.playlist.songs.push(element);
                });
            });
            this.playlist.songs = _.uniqBy(this.playlist.songs, 'id');
            this.scrollParams.page++;
        }
    }

    ngOnDestroy() {
        if (this.scrollSubscriber != null) {
            this.scrollSubscriber.unsubscribe();
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/playlists/playlist-detail/playlist-detail.component.ts